{
  "zh-CN": {
    "dressingRoom": {
      "lead": "把护甲和内衬服搭配在一起，以 3D 查看装扮。通过链接分享，或登录后保存。",
      "slots": {
        "helmet": "头盔",
        "torso": "躯干",
        "arms": "手臂",
        "legs": "腿部",
        "backpack": "背包",
        "undersuit": "内衬服",
        "primary": "主武器",
        "secondary": "副武器",
        "sidearm": "手枪"
      },
      "size": "S%{size}",
      "choose": "选择…",
      "remove": "移除",
      "openItem": "打开物品页面",
      "notFound": "未找到物品",
      "noHolo": "暂无 3D 模型",
      "empty": "为任意槽位选择一件装备即可查看装扮。",
      "pose": "姿势",
      "copyLink": "复制链接",
      "savedOutfits": "已保存的装扮",
      "signInToSave": "登录后即可保存装扮。",
      "outfitName": "装扮名称",
      "nameTaken": "你已经有一套同名的装扮。",
      "saveNew": "另存为新装扮",
      "saveChanges": "保存更改",
      "noOutfits": "还没有保存的装扮。",
      "pieces": {
        "one": "%{count} 件",
        "other": "%{count} 件"
      },
      "confirmDelete": "删除装扮 %{name}？",
      "messages": {
        "saved": "装扮已保存。",
        "saveFailed": "无法保存装扮。",
        "deleteFailed": "无法删除装扮。",
        "linkCopied": "链接已复制。",
        "copyFailed": "无法复制链接。"
      },
      "groups": {
        "armour": "护甲",
        "weapons": "武器",
        "gear": "装备"
      },
      "hold": "手持",
      "bodies": {
        "male": "男性",
        "female": "女性"
      },
      "positionPending": "位置尚未导出",
      "fit": {
        "noPort": "%{item} 没有此槽位",
        "doesNotFit": "与 %{item} 不兼容",
        "noWornPiece": "所穿部件没有可放置此物的位置"
      },
      "armorSets": {
        "open": "护甲套装",
        "count": {
          "one": "%{count} 套",
          "other": "%{count} 套"
        }
      },
      "gearHint": "穿上躯干、腿甲或内衬服，即可携带手雷、弹匣、针剂和工具。",
      "gear": {
        "grenade": "手雷 %{number}",
        "magazine": "弹匣 %{number}",
        "gadget": "小工具",
        "medpen": "医疗笔 %{number}",
        "oxypen": "氧气笔 %{number}",
        "utility": "工具 %{number}"
      },
      "saveBlocked": "请先修正上方标记的问题，再保存此装扮。",
      "storage": {
        "title": "储物",
        "space": "%{used} / %{capacity}",
        "add": "添加物品",
        "fewer": "减少一个",
        "more": "增加一个",
        "pickerTitle": "添加到%{piece}",
        "problems": {
          "noStorage": "此处没有穿戴可容纳这些物品的部件。",
          "overCapacity": "所存物品超出此部件的容量。",
          "tooLarge": "存有对此部件来说过大的物品。",
          "unmeasured": "存有没有测量尺寸的物品。"
        },
        "misfit": {
          "unmeasured": "没有测量尺寸",
          "tooLarge": "对此部件来说过大",
          "noRoom": "剩余空间不足"
        }
      },
      "gearNone": "你所穿的部件没有装备槽位。",
      "gearColumns": {
        "magazine": "弹药",
        "grenade": "手雷",
        "medpen": "医疗笔",
        "oxypen": "氧气笔"
      }
    }
  }
}
